import React from 'react';
import RichLayout from '@components/_struct/_layouts/RichLayout';
import { useMSTranslation } from '@utils/useMSTranslation';
import Head from 'next/head';

const Donnees = () => {
    const { __ } = useMSTranslation(['donnees']);
    return (
        <RichLayout>
            <Head>
                <title>
                    {__('Données personnelles', 'donnees')} | Viseet.me
                </title>
            </Head>
            <h1>{__('Traitement des données personnelles', 'donnees')}</h1>
            <p>
                {__(
                    'La présente ANNEXE Traitement des données personnelles régit les rapports entre d’une part, la société VISEET, société par actions simplifiée, au capital de 256 413 euros, immatriculée au registre du commerce et des sociétés de Nanterre sous le numéro 897 655 643, dont le siège social est situé 59 rue de l’Ancienne Mairie, 92100 Boulogne Billancourt (ci-après « VISEET ») et d’autre part, tout organisateur d’événement (ci-après l’ « Organisateur ») utilisant les logiciel en ligne développé par VISEET.',
                    'donnees'
                )}
            </p>
            <h2>{__('Définitions', 'donnees')}</h2>
            <p>
                {__(
                    'Dans les CGU, les termes et expressions identifiés par une majuscule ont la signification indiquée ci-après, qu’ils soient employés au singulier ou au pluriel.',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Evénements » : désigne les manifestations organisées par l’Organisateur sur la plateforme et auxquels participent les Invités ;',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Invité » : désigne toute personne invitée par l’Organisateur à s’inscrire et participer à l’Evénement en utilisant le Service;',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Organisateur » : désigne la personne morale organisant un Evénement, auquel elle invite des Invités en utilisant le Service;',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Service » : désigne le logiciel en ligne de VISEET',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Données » : désigne les informations personnelles collectées en ligne sur les invités, chargées dans le logiciel d’VISEET SAS par le client au moyen du formulaire d’inscription.',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Prestation » : l’ensemble du service commandé par l’Organisateur à VISEET et couvert par les CGU.',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    '« Traitement » : l’ensemble du procédé de collecte et d’utilisation des informations personnelles des invités sur les plateformes VISEET pour l’organisation de l’événement de l’organisateur, à titre indicatif en voici la liste :',
                    'donnees'
                )}
            </p>
            <ul>
                <li>{__('Inviter des “invités”', 'donnees')}</li>
                <li>{__('Exports des listes d’invitation', 'donnees')}</li>
                <li>{__('Envois des emails d’invitations', 'donnees')}</li>
                <li>{__('Formulaires d’inscription', 'donnees')}</li>
                <li>{__('Exports de de listes de participants', 'donnees')}</li>
                <li>
                    {__(
                        'Inscription via le formulaire d’inscription',
                        'donnees'
                    )}
                </li>
                <li>{__('Sélectionner des “invités”', 'donnees')}</li>
                <li>{__('Confirmer des “Invités”', 'donnees')}</li>
                <li>
                    {__(
                        'Envoyer des emails de confirmation d’inscription',
                        'donnees'
                    )}
                </li>
                <li>
                    {__(
                        'Faire participer les “Invités” à l’événement en visioconférence',
                        'donnees'
                    )}
                </li>
                <li>
                    {__(
                        'Inviter les “Invités” dans un salon virtuel',
                        'donnees'
                    )}
                </li>
                <li>{__('Echanger avec les invités par chat', 'donnees')}</li>
            </ul>
            <h2>{__('Informations relatives aux traitements', 'donnees')}</h2>
            <h3>
                {__(
                    'a) Respect des principes français et européen en matière de protection des données personnelles',
                    'donnees'
                )}
            </h3>
            <p>
                {__(
                    'Les Parties s’engagent à collecter et à traiter toute donnée personnelle en conformité avec toute réglementation en vigueur applicable au traitement de ces données, et notamment à la loi n°78-17 du 6 janvier 1978 modifiée.',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    'Au regard de cette loi, l’Organisateur est responsable du Traitement réalisé au titre du Contrat.',
                    'donnees'
                )}
            </p>
            <h3>
                {__(
                    'b) Existence d’un système de remontée des plaintes et des failles de sécurité',
                    'donnees'
                )}
            </h3>
            <p>
                {__(
                    'Le Prestataire s’engage à communiquer au Client la survenance de toute faille de sécurité ayant des conséquences directes ou indirectes sur le Traitement, ainsi que toute plainte qui lui serait adressée par tout individu concerné par le Traitement réalisé au titre du Contrat. Cette communication devra être effectuée dans les plus brefs délais et au maximum quarante-huit heures après la découverte de la faille de sécurité ou suivant réception d’une plainte.',
                    'donnees'
                )}
            </p>
            <h3>{__('c) Moyens de traitement', 'donnees')}</h3>
            <p>
                {__(
                    'Afin d’exécuter la Prestation, le Prestataire traitera les Données par le biais des moyens de traitement suivants :',
                    'donnees'
                )}
            </p>
            <p>
                {__(
                    'Logiciel en ligne VISEET.ME (Invitation, Inscription)',
                    'donnees'
                )}
            </p>
            <h3>{__('d) Sous-traitance', 'donnees')}</h3>
            <p>
                {__(
                    'Le Prestataire informe le Client, qui l’accepte, qu’il fera sous-traiter l’exécution du Contrat par les sous-contractants suivants :',
                    'donnees'
                )}
            </p>
            <ul>
                <li>
                    <p>
                        {__(
                            'OVH (Infrastructure as a Service, cloud)',
                            'donnees'
                        )}
                    </p>
                    <p>
                        {__(
                            'Les services OVH sont conformes au règlement général sur la protection des données (RGPD).',
                            'donnees'
                        )}
                    </p>
                </li>
                <li>
                    <p>{__('Daily.co (visioconférence)', 'donnees')}</p>
                    <p>
                        {__(
                            'Le Prestataire restera seul responsable vis-à-vis du Client de l’exécution de ses obligations contractuelles résultant de ce document.',
                            'donnees'
                        )}
                    </p>
                </li>
            </ul>
            <h3>
                {__(
                    'e) Existence de procédures simples permettant de respecter les droits des personnes concernées vis-à-vis de leurs données',
                    'donnees'
                )}
            </h3>
            <p>
                {__(
                    'Le Prestataire s’engage à coopérer avec le Client et à l’aider à satisfaire aux exigences légales relatives à la protection des données à caractère personnel qui incombent à ce dernier, afin notamment de respecter les droits des personnes concernées en vertu des articles 38 à 43 de la loi n°78-17 du 6 janvier 1978 modifiée.',
                    'donnees'
                )}
            </p>
            <h2>{__('Localisation et transferts', 'donnees')}</h2>
            <h3>{__('a) Destinataires', 'donnees')}</h3>
            <p>
                {__(
                    'Le Prestataire devra fournir au Client toute information utile concernant les destinataires des Données, afin que ce dernier soit en mesure d’informer les personnes concernées par le Traitement et de répondre à leurs demandes d’accès en vertu des articles 32 et 39 de la loi n°78-17 du 6 janvier 1978 modifiée.',
                    'donnees'
                )}
            </p>
            <h3>
                {__(
                    'b) Indication claire et exhaustive des pays hébergeant les serveurs du prestataire',
                    'donnees'
                )}
            </h3>
            <p>
                {__(
                    'Le Prestataire informe le Client que les Données seront hébergées dans des serveurs localisés dans les pays suivants : France.',
                    'donnees'
                )}
            </p>
            <h2>{__('Formalités auprès de la CNIL', 'donnees')}</h2>
            <p>
                {__(
                    'Le Client s’acquittera des formalités déclaratives relatives au Traitement auprès des autorités de protection des données à caractère personnel compétentes. Le Prestataire s’engage à lui fournir toute information utile afin de procéder à ces formalités.',
                    'donnees'
                )}
            </p>
            <h2>{__('Sécurité et confidentialité', 'donnees')}</h2>
            <h3>
                {__(
                    'a) Indication des obligations incombant au prestataire en matière de sécurité des données et précision qu’il ne peut agir que sur instruction du client',
                    'donnees'
                )}
            </h3>
            <p>
                {__(
                    'Dans le cadre de l’exécution du Contrat, le Prestataire agira uniquement sur les instructions du Client. A ce titre, le Prestataire s’engage à ne pas utiliser les Données pour son propre compte ou pour celui d’un tiers. Conformément à l’article 34 de la loi Informatique et Libertés modifiée, le Prestataire s’engage à prendre toutes précautions utiles afin de préserver la sécurité des informations et notamment de les protéger contre toute destruction accidentelle ou illicite, perte accidentelle, altération, diffusion ou accès non autorisés, notamment lorsque le Traitement comporte des transmissions de données dans un réseau, ainsi que contre toute autre forme de traitement illicite ou communication à des personnes non autorisées',
                    'donnees'
                )}
            </p>
            <h3>
                {__(
                    'b) Politique de sécurité et mesures de sécurité',
                    'donnees'
                )}
            </h3>
            <p>
                {__(
                    'Le Prestataire fournit au Client la politique de sécurité des systèmes d’information qu’il a mise en place et l’informe des évolutions de cette politique. Il tient à la disposition du client les documents relatifs à la sécurité de ses données comprenant notamment la documentation technique nécessaire, les analyses de risques produites et la liste détaillée des mesures de sécurité mises en œuvre. Les supports informatiques et documents fournis par le Client au Prestataire restent la propriété du Client. Les données contenues dans ces supports et documents sont strictement couvertes par le secret professionnel (article 226-13 du code pénal), il en va de même pour toutes les données dont le Prestataire prend connaissance à l’occasion de l’exécution du Contrat. Le Prestataire s’engage à respecter les obligations suivantes et à les faire respecter par son personnel :',
                    'donnees'
                )}
            </p>
            <ul>
                <li>
                    {__(
                        'ne prendre aucune copie des documents et supports d’informations qui lui sont confiés, à l’exception de celles nécessaires à l’exécution de la présente prestation prévue au Contrat avec l’accord préalable du Client ;',
                        'donnees'
                    )}
                </li>
                <li>
                    {__(
                        'ne pas utiliser les documents et informations traités à des fins autres que celles spécifiées au présent contrat ;',
                        'donnees'
                    )}
                </li>
                <li>
                    {__(
                        'ne pas divulguer ces documents ou informations à d’autres personnes, qu’il s’agisse de personnes privées ou publiques, physiques ou morales ;',
                        'donnees'
                    )}
                </li>
                <li>
                    {__(
                        'prendre toutes mesures permettant d’éviter toute utilisation détournée ou frauduleuse des fichiers informatiques en cours d’exécution du contrat.',
                        'donnees'
                    )}
                </li>
            </ul>
        </RichLayout>
    );
};

Donnees.getInitialProps = async () => {
    return {
        namespacesRequired: ['common']
    };
};

export default Donnees;
